module.exports = __webpack_public_path__ + "static/media/rh.055741ab.jpg";